import React from 'react';

export const BloodPressureValueDisplay = ({
  systolicMeasurement,
  diastolicMeasurement,
  canEdit,
  onClick,
}) => {
  const unit = systolicMeasurement?.unit || diastolicMeasurement?.unit || '';
  return (
    <div
      className={`measurement-value-display ${canEdit ? 'measurement-value-editable' : ''}`}
      onClick={onClick}
      onMouseMove={(e) => {
        const tooltip = e.currentTarget.querySelector('.edit-tooltip');
        if (tooltip) {
          tooltip.style.left = `${e.clientX + 10}px`;
          tooltip.style.top = `${e.clientY + 10}px`;
        }
      }}
    >
      <span>{systolicMeasurement?.value ?? ''}</span>
      <span className="bp-separator" aria-hidden="true">/</span>
      <span>{diastolicMeasurement?.value ?? ''}</span>
      {unit ? <span className="bp-unit">{unit}</span> : null}
      {canEdit && <div className="edit-tooltip">Click to edit measurement</div>}
    </div>
  );
};

export const BloodPressureValueEditor = ({
  containerRef,
  systolicInputRef,
  systolicValue,
  diastolicValue,
  unit,
  onSystolicChange,
  onDiastolicChange,
  onUnitChange,
  onKeyDown,
}) => (
  <div
    ref={containerRef}
    className="measurement-edit-container measurement-edit-container-bp"
    onKeyDown={onKeyDown}
  >
    <div className="bp-reading-fields">
      <input
        ref={systolicInputRef}
        type="number"
        step="any"
        value={systolicValue}
        onChange={(e) => onSystolicChange(e.target.value)}
        className="measurement-value-input"
        placeholder="Sys"
        aria-label="Systolic blood pressure"
      />
      <span className="bp-separator" aria-hidden="true">/</span>
      <input
        type="number"
        step="any"
        value={diastolicValue}
        onChange={(e) => onDiastolicChange(e.target.value)}
        className="measurement-value-input"
        placeholder="Dia"
        aria-label="Diastolic blood pressure"
      />
    </div>
    <input
      type="text"
      value={unit}
      onChange={(e) => onUnitChange(e.target.value)}
      className="measurement-unit-input"
      placeholder="Unit"
    />
  </div>
);
